import { render, staticRenderFns } from "./ServicesCenters.vue?vue&type=template&id=6675a34e&scoped=true&"
import script from "./ServicesCenters.vue?vue&type=script&lang=js&"
export * from "./ServicesCenters.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCenters.vue?vue&type=style&index=0&id=6675a34e&prod&lang=scss&scoped=true&"
import style1 from "./ServicesCenters.vue?vue&type=style&index=1&id=6675a34e&prod&lang=scss&"
import style2 from "./ServicesCenters.vue?vue&type=style&index=2&id=6675a34e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675a34e",
  null
  
)

export default component.exports